import React, { useState } from "react";
import TableComponent from "../../../components/TableComponent/TableComponentFiltro";

export const Distritos = () => {
  const cabeceras = ["Id", "Nombre", "Región", "Área", "Editar", "Eliminar"];

  const [parametros] = useState({
    action: "datatable",
    table: "districts A INNER JOIN regions B USING (keyRegion)",
    rows: "keyDistrict,nameDistrict,keyRegion,nameRegion",
    conditions: "A.enabled = 1 AND B.enabled = 1",
    page: 0,
    records: 5,
    search: "",
    order: "",
  });

  return (
    <div>
      <TableComponent
        titulo="Distritos"
        cabecerasTabla={cabeceras}
        filtro={null}
        rutaCrear="/template/distritos/crear"
        rutaEditar="/template/distritos/editar"
        parametros={parametros}
      ></TableComponent>
    </div>
  );
};
export default Distritos;
